<template>
  <div class="slide-page">
    <NavBarM @jump="jump" ref="navbar"></NavBarM>
    <!-- 公司简介 -->
    <div class="slide-content" ref="content" style="">
      <div style="padding: 0.3rem">
        <img
          class="title-img"
          src="../../assets/img/label-OV.png"
          alt=""
        />

        <p>
          为实现国家治理体系治理能力现代化要求，成为财政财务治理立体化服务的先行者，成立于<span style="color:#ea0;">二〇〇五年</span>的日浩，一直致力于构建更为优秀的专业团队，提供更加全面的产品结构，打造更为智能的服务系统，鼓励自我提升，共享战略理念，对服务成果执行高质量，对服务绩效采取高标准。
        </p>
    
    <p>
      我们已建设了集政、产、学、研于一身的超<span style="color:#ea0;">四百名</span>的专业服务团队，努力达成服务标准化和个性化的完美平衡，确保在恰当的时间以恰当的价格，为您提供卓越的服务，与您共进！
    </p>
    <p>
      我们聚焦<span style="color:#ea0;">预算绩效、内部控制、财务报告</span>等财政财务领域，联合国内知名高等学府及科研机构建立政策法规库、专家库、数据案例库，形成了优质高效的产品核心理念：
    </p>
    <div style="font-size: 0.44rem;font-weight:bold;text-align:center;">以政策为导向、以法规为依据、以决策为基础；</div>
    <div style="font-size: 0.44rem;font-weight:bold;text-align:center;">以预算为龙头、以绩效为目标、以资金为主线；</div>
    <div style="font-size: 0.44rem;font-weight:bold;text-align:center;">以内控为底线、以会计为反映、以报表为结果；</div>
    <div style="font-size: 0.44rem;font-weight:bold;text-align:center;">以评价为手段、以审计为监督、以数智为支撑。</div>
    <p>为行政事业单位提供数智化实现的产品领先、全面完善、总成本最低的财政财务治理体系治理能力现代化立体服务方案。</p>
    
        <img style="" src="../../assets/img/ovc2.png" alt="" />
<p>
      产品理念——为客户提供数智化实现的产品领先、全面完善、总成本最低的财政财务治理体系治理能力现代化立体服务方案。
    </p>
    <p>服务业绩——近五年服务行政事业单位客户超两千家，承接项目超五千个，年均服务客户超一千六百家，主要客户重复服务率超90%；其中数智化产品使用单位超千家，个人用户超七万人，办理资金规模超千亿元，处理业务超四百万笔，产品控制点超一千八百个。</p>
    <p>服务层级——为中央、省、市、县（区）、乡镇（街道）行政事业单位提供纵向全层级、横向全覆盖的专业服务，受财政部委托执行了中央本级政府综合财务报告编报工作。</p>
    <p>学术研究——应邀参加财政部预算管理、内部控制、政府财务报告等政策研究；参与编写上财《政府与非营利组织会计》教材部分章节。</p>
    <p>学术论坛——连续三年成功举办“财政财务管理鹏城论坛”。</p>
    <p>法规平台——研究并发布财政财务解构型法规库小程序。</p>
    <p>领域支撑——为国内顶级科技公司实施的财政财务管理系统研发提供底层逻辑和平台维护。</p>
    
      </div>
    </div>
    <FooterM></FooterM>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import NestedScroll from "@better-scroll/nested-scroll";
import NavBarM from "../../components/NavBarM.vue";
import FooterM from "../../components/FooterM.vue";
BScroll.use(NestedScroll);
export default {
  components: {
    FooterM,
    NavBarM,
  },
  data() {
    return {
      bScroll: null,
    };
  },
  methods: {
    jump(index) {
      this.$emit("jump", index);
    },
  },
  mounted() {
    this.bScroll = new BScroll(this.$refs.content, {
      scrollY: true,
      scrollX: false,
      bounce: false,
      probeType: 3,
      click: true,
      nestedScroll: {
        groupId: "asdf",
      },
    });
    this.bScroll.on("beforeScrollStart", () => {
      this.$refs.navbar.hidden();
    });
  },
};
</script>

<style scoped>
.slide-page {
}
</style>
